<template>
  <div class="home">
    <b-container>
      <div class="row">
        <div class="col-lg-6 col-md-6 m-auto auth-form text-center">
          <h3 class="mb-4">Enter two factor authentication passcode</h3>
          <b-card>
            <form @submit.prevent="verifyOtp">
              <p><strong>We’ve sent a 6-digit code to your email</strong></p>
              <p class="mb-4">Enter your passcode</p>

              <div class="otp-inputs d-flex justify-content-center mb-3">
                <input v-for="(digit, index) in otp" :key="index" type="text" maxlength="1" class="otp-box"
                  v-model="otp[index]" @input="onInput($event, index)" @keydown.backspace="focusPrev($event, index)"
                  @paste="handlePaste($event)" inputmode="numeric" />
              </div>

              <div class="text-center">
                <b-button class="btn-om-solid" type="submit" size="lg" :disabled="loading || otp.join('').length < 6">
                  <span class="spinner-border spinner-border-sm position-relative" style="top: -3px"
                    v-show="loading"></span>
                  Verify
                </b-button>
              </div>
            </form>

            <div class="mt-3">
              <b-link href="javascript:void(0)" @click="resendOtp" :disabled="resending" class="text-dark">
                Resend code
              </b-link>
            </div>

            <p v-if="error" class="text-danger mt-2">{{ error }}</p>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: ["", "", "", "", "", ""],
      email: this.$route.query.email || "",
      device_name: "web",
      loading: false,
      resending: false,
      error: "",
    };
  },
  methods: {
    async verifyOtp() {
      this.loading = true;
      this.error = "";

      try {
        const code = this.otp.join("");
        const data = {
          email: this.email,
          code,
          device_name: this.device_name,
        };

        const response = await this.$store.dispatch("auth/verifyOtp", data);

        if (response.access_token) {
          localStorage.setItem("token", response.access_token);
          this.$router.push({ name: "home" });
        }
      } catch (error) {
        this.error =
          error?.data?.errors?.code?.[0] ||
          error?.data?.message ||
          "Invalid or expired code.";
      }

      this.loading = false;
    },
    async resendOtp() {
      this.resending = true;
      this.error = "";

      try {
        const data = {
          email: this.email,
          device_name: this.device_name,
        };
        await this.$store.dispatch("auth/resendOtp", data);
      } catch (error) {
        this.error =
          error?.response?.data?.message ||
          error?.data?.message ||
          "Failed to resend code.";
      }

      this.resending = false;
    },
    onInput(event, index) {
      const value = event.target.value;
      if (!/^\d*$/.test(value)) {
        this.otp[index] = "";
        this.error = "Only numbers are allowed in the code.";
      } else {
        this.error = "";
        this.otp[index] = value;

        if (value && index < this.otp.length - 1) {
          this.$el.querySelectorAll(".otp-box")[index + 1].focus();
        }
      }
    },
    focusPrev(event, index) {
      if (!this.otp[index] && index > 0) {
        this.$el.querySelectorAll(".otp-box")[index - 1].focus();
      }
    },
    handlePaste(event) {
      const pasteData = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
      this.otp = pasteData.split("").map((c, i) => pasteData[i] || "");
      this.$nextTick(() => {
        const lastIndex = pasteData.length - 1;
        if (lastIndex >= 0) {
          this.$el.querySelectorAll(".otp-box")[lastIndex].focus();
        }
      });
      event.preventDefault();
    },
  },
};
</script>

<style scoped>
.otp-inputs {
  gap: 30px;
}

.otp-box {
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
</style>
